import { Text } from '@pandiafi/components'
import React from 'react'

import { BulletinType } from '../../../../../common/validations'
import { BulletinLanguageSelector } from '../BulletinLanguageSelector/BulletinLanguageSelector'

interface BulletinTitleProps {
  title: string
  language?: BulletinType['language']
  availableLanguages?: BulletinType['availableLanguages']
  onLanguageChange?: (language: BulletinType['language']) => void
}

export const BulletinTitle: React.FC<BulletinTitleProps> = ({
  title,
  language,
  availableLanguages,
  onLanguageChange,
}) => {
  return (
    <div className="flex w-full items-start justify-between gap-4">
      <div lang={language}>
        <Text element="h2" size="l" weight="semibold">
          {title}
        </Text>
      </div>

      {language && availableLanguages && onLanguageChange && (
        <BulletinLanguageSelector
          language={language}
          availableLanguages={availableLanguages}
          onLanguageChange={onLanguageChange}
        />
      )}
    </div>
  )
}
